import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTickets } from "./../../store/ticketsSlice";
import Pagination from "./Pagination";
import TicketChart from "../charts/TicketChart";
import ActiveUserChart from "../charts/ActiveUserChart";

const Tickets = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("datePurchased");
  const [filterCategory, setFilterCategory] = useState("all");

  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const ticketsPerPage = 5; // Number of tickets per page

  const dispatch = useDispatch();
  const tickets = useSelector((state) => state.tickets.tickets);

  // Logic for pagination
  const indexOfLastTicket = currentPage * ticketsPerPage;
  const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;

  // Filtering and sorting logic
  const filteredTickets = tickets
    .filter(
      (ticket) => filterCategory === "all" || ticket.category === filterCategory
    )
    .filter(
      (ticket) =>
        ticket.ticketId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.eventName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

  // Sorting logic
  const sortedTickets = [...filteredTickets].sort((a, b) => {
    if (sortBy === "dateAsc") {
      return new Date(a.datePurchased) - new Date(b.datePurchased);
    } else if (sortBy === "dateDesc") {
      return new Date(b.datePurchased) - new Date(a.datePurchased);
    }
    return 0; // Default case (no sorting)
  });

  const currentTickets = sortedTickets.slice(
    indexOfFirstTicket,
    indexOfLastTicket
  );

  const totalPages = Math.ceil(filteredTickets.length / ticketsPerPage);
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  // Function to format the date
  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const date = new Date(dateString);
    return date.toLocaleString("fr-FR", options);
  };

  useEffect(() => {
    dispatch(fetchTickets());
  }, [dispatch]);

  console.log(tickets);

  return (
    <div className=" p-6 rounded-lg shadow bg-white">
      <div className="flex justify-between mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Ticket Management</h1>
      </div>
      <div className="flex flex-col gap-10 mb-8 items-center justify-between md:flex-row">
        <div className="w-full md:w-1/3 p-4">
          <TicketChart tickets={tickets} />
        </div>
        <div className="w-full md:w-2/3 p-4">
          <ActiveUserChart tickets={tickets} />
        </div>
      </div>

      <div className="mb-6 flex flex-col sm:flex-row items-center gap-4">
        <div className="relative flex-grow">
          <input
            type="text"
            placeholder="Search tickets..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <svg
            className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <div className="flex items-center gap-2">
          <svg
            className="h-5 w-5 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
            />
          </svg>
          <select
            className="pl-2 pr-8 py-2 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="default">Sort by default</option>
            <option value="dateAsc">Sort by purchase date (Asc)</option>
            <option value="dateDesc">Sort by purchase date (Desc)</option>
          </select>
        </div>
        <div className="flex items-center gap-2">
          <svg
            className="h-5 w-5 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            />
          </svg>
          <select
            className="pl-2 pr-8 py-2 border border-gray-300 rounded-lg appearance-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            <option value="Concerts">Concerts</option>
            <option value="Theater">Theater</option>
            <option value="Comedy">Comedy</option>
            <option value="Sports">Sports</option>
            <option value="Educational">Educational</option>
          </select>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              {" "}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                User info
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Ticket ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Event Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Event Category
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Purchase Date
              </th>
              {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th> */}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentTickets.map((ticket) => (
              <tr
                key={ticket.ticketId}
                className="hover:bg-gray-50 transition-colors duration-200"
              >
                <td className="px-6 py-4  text-sm text-gray-500">
                  <span className="font-medium text-gray-900">
                    {ticket.fullName}
                  </span>
                  <br />
                  {ticket.email ? ticket.email : "-"}
                  <br />
                  {ticket.phoneNumber ? ticket.phoneNumber : "-"}
                </td>
                <td className="px-6 py-4  text-sm font-medium text-gray-900">
                  {ticket.ticketId}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {ticket.eventName}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      ticket.category === "Concerts"
                        ? "bg-blue-100 text-blue-800"
                        : ticket.category === "Theater"
                        ? "bg-purple-100 text-purple-800"
                        : ticket.category === "Comedy"
                        ? "bg-yellow-100 text-yellow-800"
                        : ticket.category === "Sports"
                        ? "bg-green-100 text-green-800"
                        : ticket.category === "Educational"
                        ? "bg-red-100 text-red-800"
                        : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {ticket.category}
                  </span>
                </td>

                <td className="px-6 py-4  text-sm text-gray-500">
                  {formatDate(ticket.datePurchased)}
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button className="text-indigo-600 hover:text-indigo-900 mr-4">
                    <svg
                      className="h-5 w-5 inline-block mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                    Edit
                  </button>
                  <button className="text-red-600 hover:text-red-900">
                    <svg
                      className="h-5 w-5 inline-block mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                    Delete
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
        />
      </div>
    </div>
  );
};

export default Tickets;
